<h6 class="prd-h6"> Update Agenda Cases </h6>
<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="card" >
    <div class="card-body" *ngIf='displayState.workingDiv'>
        <div class="row" >
            <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
        </div>
        <div class="row">
            <div class="col-md-2 offset-5">
                <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
            </div>
        </div>
    </div>
</div>
<br />

<div class="row" *ngIf='displayState.gridDiv'>
  <div class="col-md-3 offset-1">
    <p-table [value]="hearingDateList" [scrollable]="true" scrollHeight="570px"  >
      <ng-template pTemplate="header">
          <tr style="font-size:small;">
              <th style="width: 5%;" >&nbsp;</th>
              <th style="width: 10%;" >
                  Hearing Date/Time - Board #
              </th>
          </tr>
      </ng-template>
      <ng-template pTemplate="body" let-hearing>
          <tr style="font-size: small;">
              <td style="width: 5%;">
                  <button class='btn btn-sm btn-link' (click)="onSelectHearing(hearing)">Select</button>
              </td>
              <td style="width: 10%;">{{hearing.hearingDate | date:"MM/dd/yyyy"}} {{hearing.hearingTime}} - Board: {{hearing.boardNumber}}</td>
          </tr>
      </ng-template>
    </p-table>
  </div>
  <div *ngIf='displayState.caseListDiv' class="col-md-5 offset-1">
    <p-table #cns [columns]="cols" [value]="caseList" [responsive]="true" [scrollable]="true" scrollHeight="510px" [(selection)]="selectedCases" dataKey="applicationId" >
        <ng-template pTemplate="caption">
            <strong>Cases on: </strong> {{myHearing.hearingDate | date: 'MM/dd/yyyy'}} {{myHearing.hearingTime}} - Board: {{myHearing.boardNumber}}
        </ng-template>

        <ng-template pTemplate="header">
            <tr style="font-size:small;">
                <th style="width: 3%;">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th style="width: 5%;" >Case # </th>
                <th style="width: 20%;" >Applicant</th>
                <th style="width: 10%;">Agenda Section</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-case>
            <tr [pSelectableRow]="case" style="font-size: small;">
                <td style="width: 3%;">
                    <p-tableCheckbox [value]="case"></p-tableCheckbox>
                </td>
                <td style="width: 5%;">{{case.caseNum}}</td>
                <td style="width: 20%;">{{case.applicantName}}</td>
                <td style="width: 10%;">{{case.agendaSection}}</td>
            </tr>
        </ng-template>
        <ng-template *ngIf="caseList.length>0" pTemplate="summary">
            <div class="row">
                <div class="col-md-4 offset-1" style="text-align: left;"># of cases: {{ caseList.length }}</div>
                <div class="col-md-4 offset-1" style="text-align: left;"># of selected cases: {{ +selectedCases?.length }}</div>
            </div>
        </ng-template>
    </p-table>
    <hr />
    <div class="form-row" style="font-size: small;">
        <!-- Buttons -->
        <button title="View ALL Withdrawal requests" class="btn btn-success offset-2 col-md-3" (click)="viewWithdrawals()">Accept Withdrawals</button>
        <button title="Update Status, etc for cases selected above" class="btn btn-warning offset-2 col-md-3" (click)="updateCases()" [disabled]="selectedCases?.length<1">Update Case(s)</button>
    </div>
  </div>
</div>

<div *ngIf="displayState.updateCasesDiv" class="card col-md-10 offset-1" style="background-color: #f4fafe; font-size: small;">
    <div class="card-body">
        <div class="form-row">
            <div class="col-md-7">
                <div class="form-row">
                    <label for="caseNum" class="col-md-2 col-form-label prd-label">Case #</label>
                    <input id="caseNum" class="form-control col-md-6" [(ngModel)]='myCase.caseNum' readonly>
                </div>
                <hr class="col-md-10 prd-hr" />
                <div class="form-row">
                    <label for="applicant" class="col-md-2 col-form-label prd-label">Applicant</label>
                    <input id="applicant" class="form-control col-md-6" [(ngModel)]='myCase.applicantName' readonly>

                </div>
                <hr class="col-md-10 prd-hr" />
                <div class="form-row">
                    <label for="statusDate" class="col-md-2 col-form-label prd-label">Status Date</label>
                    <input id="statusDate" class="form-control col-md-6" [(ngModel)]='myCase.statusDate' readonly>
                </div>
                <hr class="col-md-10 prd-hr" />
                <div class="form-row">
                    <label for="status" class="col-md-2 col-form-label prd-label">Status</label>
                    <select [(ngModel)]="myCase.status" id="status" class="form-control col-md-6 prd-required">
                        <option [ngValue]="0"></option>
                        <option [ngValue]="stat" *ngFor="let stat of statusList"> {{ stat }}</option>
                    </select>
                </div>
                <hr class="col-md-10 prd-hr" />
                <div class="form-row">
                    <label for="subStatus" class="col-md-2 col-form-label prd-label">Sub-Status</label>
                    <select [(ngModel)]="myCase.subStatus" id="subStatus" class="form-control col-md-6">
                        <option [ngValue]="0"></option>
                        <option [ngValue]="substat" *ngFor="let substat of subStatusList"> {{substat}}</option>
                    </select>
                </div>
                <hr class="col-md-10 prd-hr" />
                <div class="form-row">
                    <label for="hearingDate" class="col-md-2 col-form-label prd-label">Hearing Date</label>
                    <select id="hearingDate" style="width: 150px;" title="Select a date" [(ngModel)]="myCase.hearingDateIndex" class="form form-input">
                        <option value=""></option>
                        <!-- <option *ngFor="let opt of futureHearingDateList; index as i" [ngValue]="i">{{opt.hearingDate | date:"MM/dd/yyyy"}}</option> -->
                      <option *ngFor="let opt of futureHearingDateList; index as i" [ngValue]="i">{{opt.hearingDateDesc}}</option>
                    </select>
                </div>
                <hr class="col-md-10 prd-hr" />
                <div *ngIf='isStipulation()' class="form-row">
                    <label for="motionBy" class="col-md-2 col-form-label prd-label">Motion By</label>
                    <input id="motionBy" class="form-control col-md-6" [(ngModel)]='myCase.motionBy'>
                </div>
                <hr *ngIf='isStipulation()' class="col-md-10 prd-hr" />
                <div class="form-row">
                    <label for="minutesText" class="col-md-2 col-form-label prd-label"> Minutes</label>
                    <textarea id="minutesText" rows="5" [(ngModel)]='myCase.minutesText' class="form-control col-md-6"></textarea>
                </div>
            </div>
            <div class="col-md-4" *ngIf='selectedCases.length==1&&myValueFinal'>
                <table class="table table-responsive">
                    <tr style="font-size: smaller">
                        <th>&nbsp;</th>
                        <th>Appeals Board Valuation</th>
                    </tr>
                    <tr>
                        <td class="prd-label"> Land </td>
                        <td> <input class="form-control" [(ngModel)]='myValueFinal.landValue' (change)='calcValues()' (blur)="addCommas(0)" (focus)="removeCommas(0)"> </td>
                    </tr>
                    <tr>
                            <td class="prd-label" > Improvements </td>
                            <td> <input class="form-control" [(ngModel)]='myValueFinal.improveValue' (change)='calcValues()' (blur)="addCommas(1)" (focus)="removeCommas(1)"> </td>
                    </tr>
                    <tr>
                            <td class="prd-label"> Fixtures </td>
                            <td> <input class="form-control" [(ngModel)]='myValueFinal.fixturesValue' (change)='calcValues()' (blur)="addCommas(2)" (focus)="removeCommas(2)"> </td>
                    </tr>
                    <tr>
                            <td class="prd-label"> Personal Property </td>
                            <td> <input class="form-control" [(ngModel)]='myValueFinal.personalValue' (change)='calcValues()' (blur)="addCommas(3)" (focus)="removeCommas(3)"> </td>
                    </tr>
                    <tr>
                            <td class="prd-label"> Mineral Rights </td>
                            <td> <input class="form-control" [(ngModel)]='myValueFinal.mineralValue' (change)='calcValues()' (blur)="addCommas(4)" (focus)="removeCommas(4)"> </td>
                    </tr>
                    <tr>
                            <td class="prd-label"> Trees and Vines </td>
                            <td> <input class="form-control" [(ngModel)]='myValueFinal.treesValue' (change)='calcValues()' (blur)="addCommas(5)" (focus)="removeCommas(5)"> </td>
                    </tr>
                    <tr>
                            <td class="prd-label"> Total Value </td>
                            <td>{{myValueFinal.totalValue | currency:'USD':'$':'1.0-0'}}  </td>
                    </tr>
                    <tr>
                            <td class="prd-label"> Exemptions </td>
                            <td> <input class="form-control" [(ngModel)]='myValueFinal.exemptValue' (change)='calcValues()' (blur)="addCommas(6)" (focus)="removeCommas(6)"> </td>
                    </tr>
                    <tr>
                            <td class="prd-label"> Penalties </td>
                            <td> <input class="form-control" [(ngModel)]='myValueFinal.penaltyValue' (change)='calcValues()' (blur)="addCommas(7)" (focus)="removeCommas(7)"> </td>
                    </tr>
                    <tr>
                            <td class="prd-label"> Net Total </td>
                            <td> <input class="form-control" [(ngModel)]='myValueFinal.netValue' (blur)="addCommas(8)" (focus)="removeCommas(8)"> </td>

                    </tr>
                </table>

            </div>
        </div>
    </div>
    <hr class="prd-hr" />
    <div class="form-row" style="font-size: smaller; margin-bottom: 5px;">
        <!-- Buttons -->
        <button title="Generate Minutes text based on data collected on this page" class="btn btn-info prd-button offset-1 col-md-2" (click)="prepMinutesText()">Generate Minutes</button>
        <button hidden title="Get Assessor-entered valuations" class="btn btn-info prd-button col-md-2" [disabled]='selectedCases.length>1' (click)='getAssessorValues()'>Get Assessed Value</button>
        <button title="Clear text entered in Motion By field, if applicable" class="btn btn-info prd-button col-md-2" (click)='clearMotionBy()' [disabled]='!isStipulation()'>Clear Motion By</button>
        <button title="Exit this page, w/o saving any data" class="btn btn-warning prd-button col-md-2" (click)='cancelUpdateCases()'>Cancel</button>
        <button title="Apply entered data to selected cases" class="btn btn-success prd-button col-md-2" (click)='executeUpdateCases()'>Save</button>
    </div>

</div>
<div *ngIf="displayState.withdrawalsDiv" class="card col-md-10 offset-1">
    <div class="card-body">
        <p-table #wc [columns]="cols" [value]="withdrawalCases" [responsive]="true" [scrollable]="true" scrollHeight="450px" >
            <ng-template pTemplate="caption">
                <strong>Withdrawals Received on: </strong> {{myHearing.hearingDate | date: 'MM/dd/yyyy'}} - Board: {{myHearing.boardNumber}}
            </ng-template>

            <ng-template pTemplate="header">
                <tr style="font-size:small;">
                    <th style="width: 5%;" >Case # </th>
                    <th style="width: 20%;" >Applicant</th>
                    <th style="width: 10%;">Agenda Section</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-case>
                <tr style="font-size: small;">
                    <td style="width: 5%;">{{case.caseNum}}</td>
                    <td style="width: 20%;">{{case.applicantName}}</td>
                    <td style="width: 10%;">{{case.agendaSection}}</td>
                </tr>
            </ng-template>
            <ng-template *ngIf="withdrawalCases.length>0" pTemplate="summary">
                <div class="row">
                    <div class="col-md-4 offset-1" style="text-align: center;"># of Withdrawals received: {{ withdrawalCases.length }}</div>
                </div>
            </ng-template>
        </p-table>
        <hr />
        <div class="form-row">
            <label for="withdrawalsBy" class="col-md-2 col-form-label prd-label">Accepted By</label>
            <input title="Enter the name(s) of Board Member accepting Withdrawals" id="withdrawalsBy" class="form-control col-md-6" [(ngModel)]='withdrawalsBy'>
        </div>
        <hr />
        <div class="form-row" style="font-size: small;">
            <!-- Buttons -->
            <button class="btn btn-success offset-2 col-md-3" (click)="updateWithdrawals()">Update Withdrawals</button>
            <button class="btn btn-warning offset-2 col-md-3" (click)="cancelWithdrawals()">Cancel Withdrawals</button>
        </div>
    </div>
</div>
